export default __webpack_public_path__ + "static/media/g.b508466b.jpg";